"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPageFrom = exports.convertPageElements = exports.MAX_PAGE_SIZE = exports.DEFAULT_PAGE_SIZE = void 0;
// Pagination
exports.DEFAULT_PAGE_SIZE = 25;
exports.MAX_PAGE_SIZE = 1000;
function convertPageElements(p, convert) {
    const r = {};
    r.hasNext = p.hasNext;
    r.hasPrevious = p.hasPrevious;
    r.totalElements = p.totalElements;
    r.totalPages = p.totalPages;
    r.elements = p.elements.map(convert);
    r.pageRequest = p.pageRequest;
    return r;
}
exports.convertPageElements = convertPageElements;
function createPageFrom(pageElements, totalElements, pageRequest) {
    if (!totalElements)
        totalElements = pageElements.length;
    if (pageRequest) {
        const p = { elements: pageElements };
        p.totalPages = Math.ceil(totalElements / pageRequest.pageSize);
        if (p.totalPages < 1)
            p.totalPages = 1;
        p.hasNext = pageRequest.pageNumber * pageRequest.pageSize <= totalElements;
        p.hasPrevious = pageRequest.pageNumber !== 1;
        p.totalElements = totalElements;
        p.pageRequest = pageRequest;
        return p;
    }
    else {
        const p = { elements: pageElements };
        p.hasNext = false;
        p.hasPrevious = false;
        p.totalElements = p.elements.length;
        p.totalPages = 1;
        p.pageRequest = { pageNumber: 1, pageSize: exports.DEFAULT_PAGE_SIZE };
        return p;
    }
}
exports.createPageFrom = createPageFrom;
